import React, { memo } from 'react';
import { Calendar, DollarSign, MapPin, Users } from 'lucide-react';
import { ITrip } from '../../../../Models/trips/trip.model';
import { formatDate } from '../../../../utils/date-utils';
import './overview-panels.scss';

interface TripInfoOverviewProps {
  trip: ITrip;
}

const TripInfoOverview: React.FC<TripInfoOverviewProps> = ({ trip }) => {
  const formatDateRange = () => {
    if (!trip.startDate && !trip.endDate) return 'No dates set';

    const start = trip.startDate ? formatDate(new Date(trip.startDate)) : '?';
    const end = trip.endDate ? formatDate(new Date(trip.endDate)) : '?';

    return `${start} - ${end}`;
  };

  const formatBudget = () => {
    if (!trip.budgetAmount) return 'No budget set';
    const currency = trip.budgetCurrency || 'USD';
    return `${currency} ${trip.budgetAmount.toLocaleString()}`;
  };

  const participantsCount = trip.permissions?.length || 1;

  return (
    <div className='overview-panel-content'>
      <h4 className='panel-title font-libre'>Trip Information</h4>

      <div className='panel-stats'>
        <div className='stat-item'>
          <Calendar
            size={20}
            className='stat-icon'
          />
          <div className='stat-info'>
            <div className='stat-label'>Dates</div>
            <div className='stat-value'>{formatDateRange()}</div>
            {trip.durationDays && (
              <div className='stat-sub'>
                {trip.durationDays} {trip.durationDays === 1 ? 'day' : 'days'}
              </div>
            )}
          </div>
        </div>

        <div className='stat-item'>
          <MapPin
            size={20}
            className='stat-icon'
          />
          <div className='stat-info'>
            <div className='stat-label'>Destinations</div>
            <div className='stat-value'>{trip.destinationCount || 0}</div>
            <div className='stat-sub'>
              {trip.destinationCount === 1 ? 'location' : 'locations'}
            </div>
          </div>
        </div>

        <div className='stat-item'>
          <DollarSign
            size={20}
            className='stat-icon'
          />
          <div className='stat-info'>
            <div className='stat-label'>Budget</div>
            <div className='stat-value'>{formatBudget()}</div>
          </div>
        </div>

        <div className='stat-item'>
          <Users
            size={20}
            className='stat-icon'
          />
          <div className='stat-info'>
            <div className='stat-label'>Participants</div>
            <div className='stat-value'>{participantsCount}</div>
            <div className='stat-sub'>
              {participantsCount === 1 ? 'person' : 'people'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(TripInfoOverview);
